module.exports = __webpack_public_path__ + "static/key-challenges-576618307db5a767b1d5685e9dca1cfa.png";